import { render, staticRenderFns } from "./UploadDocumentWithChain.vue?vue&type=template&id=e4ed0d60&scoped=true"
import script from "./UploadDocumentWithChain.vue?vue&type=script&lang=js"
export * from "./UploadDocumentWithChain.vue?vue&type=script&lang=js"
import style0 from "./UploadDocumentWithChain.vue?vue&type=style&index=0&id=e4ed0d60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ed0d60",
  null
  
)

export default component.exports